




























































import { Component, Vue } from 'vue-property-decorator'
import { CLOUD_DOC_URL } from '@/apps/open/constants'
import { IAppInfo } from '@/apps/open/store/modules/app/types'
import { appList } from '@/apps/open/services/app'
import moment from 'moment'
import { onRequestError } from '@/apps/open/utils'
import Button from '@/apps/open/components/Button'

@Component({
  components: {
    Button
  },
  methods: {
    moment
  }
})
export default class KdocApps extends Vue {
  apps: IAppInfo[] = []
  appsPage = 1
  appsPageSize = 10
  appsTotal = 0

  tableHeaderStyle = {
    height: '48px',
    background: '#F3F3F3',
    'text-align': 'center',
    'font-size': '18px',
    color: '#3C414B'
  }

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  mounted () {
    this.initEventListener()
    this.getAppList()
  }

  beforeDestroy () {
    this.$eventBus.$clear('changeEnterprise', this.getAppList)
  }

  initEventListener () {
    this.$eventBus.$on('changeEnterprise', this.getAppList)
  }

  jumpDevDoc () {
    window.open(CLOUD_DOC_URL)
  }

  tableRowStyle (item: any) {
    let obj: any = {
      color: '#3C414B'
    }
    let index = item.columnIndex
    let leftAlign = index === 2
    obj['text-align'] = leftAlign ? 'left' : 'center'
    return obj
  }

  get isPassed () {
    return this.$store.getters['User/isPassedEnterprise']
  }

  get curEnterprise () {
    return this.$store.getters['User/curEnterprise']
  }

  addApp () {
    this.$router.push({ name: 'add-app' })
  }

  toAppInfo (app: IAppInfo) {
    let id = app.app_id || ''
    this.$router.push({ name: 'app-setting', params: { id } })
  }

  getAppList () {
    appList({
      page: this.appsPage,
      limit: this.appsPageSize,
      developer_id: this.curEnterprise.developer_id
    })
      .then((res) => {
        const data = res.data
        this.apps = [...data.object_array]
        this.appsTotal = data.total
      }).catch((error) => {
        onRequestError(error)
      })
  }

  appsPageChange (page: number) {
    this.appsPage = page
    this.getAppList()
  }
}
